import React from "react";

export default function NumberBalls({ numbers, power }) {
  return (
    <div className="number-balls" aria-label={`Numbers ${numbers.join(", ")} and Powerball ${power}`}>
      {numbers.map((n) => (
        <span className="number-ball" key={n}>{n}</span>
      ))}
      <span className="number-ball power">{power}</span>
    </div>
  );
}
